import { ListableInfo, Panel } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { humanizeRequestStatus } from '@pages/notification-components/utils/humanizeRequestStatus';
import { capitalizeString } from '@utils/stringFormatUtils';
import { type RequestProps } from '../../models/RequestProps';
import { UrlListableInfo } from './UrlListableInfo';

export function RequestPanel({ request }: RequestProps): ReactNode {
    return (
        <Panel header="Request">
            <ListableInfo
                size="md"
                label="Requested Vendor ID"
                value={
                    request.componentVendorID ? request.componentVendorID : '-'
                }
            />
            <ListableInfo
                size="md"
                label="Requested Vendor"
                value={
                    request.componentVendor
                        ? request.componentVendor.name
                        : request.componentVendorName ?? '-'
                }
            />
            <ListableInfo
                size="md"
                label="Requested Name"
                value={request.componentName ?? '-'}
            />
            <ListableInfo
                size="md"
                label="Requested Version"
                value={request.componentVersion ?? '-'}
            />
            <ListableInfo
                size="md"
                label="Request Priority"
                value={
                    request.requestPriority
                        ? capitalizeString(request.requestPriority.toString())
                        : '-'
                }
            />
            <ListableInfo
                size="md"
                label="Request Status"
                value={humanizeRequestStatus(request.statusCode)}
            />
            <ListableInfo
                size="md"
                label="Ext. Request Status"
                value={request.externalRequestStatus ?? '-'}
            />
            <ListableInfo
                size="md"
                label="Request ID"
                value={request.id ?? '-'}
            />
            <ListableInfo
                size="md"
                label="Ext. Source"
                value={request.sourceID ?? '-'}
            />
            <ListableInfo
                size="md"
                label="Ext. Component ID"
                value={request.externalComponentID ?? '-'}
            />
            <ListableInfo
                size="md"
                label="Component ID"
                value={request.componentID ?? '-'}
            />
            <ListableInfo
                size="md"
                label="Requester"
                value={`${request.user.firstName} ${request.user.lastName}`}
            />
            <UrlListableInfo label="Website URL" url={request.referenceWeb} />
            <UrlListableInfo
                label="Security URL"
                url={request.referenceSecurity}
            />
        </Panel>
    );
}
